import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
// import IconButton from "@mui/material/IconButton";
// import Typography from "@mui/material/Typography";
// import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import Header from "../../components/Header";
// import LineChart from "../../components/LineChart";
// import GeographyChart from "../../components/GeographyChart";
// import BarChart from "../../components/BarChart";
import StatBox from "../../components/StatBox";
// import ProgressCircle from "../../components/ProgressCircle";
// import { mockTransactions } from "../../data/mocks/data";
import { useThemeColor } from "../../hooks/useThemeColor";
import { useDashboard } from "../../hooks/pages/useDashboard";

export default function Dashboard() {
  const { colors } = useThemeColor();
  const { results } = useDashboard();

  return (
    <Box m="20px">
      {/* HEADER */}
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Header title="Bem vindo ao SGI" subtitle="Sistema de Gestão para Imobiliária" />
      </Box>

      {/* GRID & CHARTS */}
      <Grid container spacing={2}>
        <Grid item sm={6} md={4} xs={12}>
          <Box
            backgroundColor={colors.primary[400]}
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ padding: 4 }}
          >
            <StatBox
              title={results?.imoveisCount || "0"}
              subtitle="Total Imóveis"
              progress="0"
              increase=""
              icon={
                <HomeWorkIcon
                  sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                />
              }
            />
          </Box>
        </Grid>
        <Grid item sm={6} md={4} xs={12}>
          <Box
            backgroundColor={colors.primary[400]}
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ padding: 4 }}
          >
            <StatBox
              title={results?.imoveisVendaCount || "0"}
              subtitle="Total Imóveis Venda"
              progress="0"
              increase=""
              icon={
                <HomeWorkIcon
                  sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                />
              }
            />
          </Box>
        </Grid>
        <Grid item sm={6} md={4} xs={12}>
          <Box
            backgroundColor={colors.primary[400]}
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ padding: 4 }}
          >
            <StatBox
              title={results?.imoveisLocacaoCount || "0"}
              subtitle="Total Imóveis Locação"
              progress="0"
              increase=""
              icon={
                <HomeWorkIcon
                  sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                />
              }
            />
          </Box>
        </Grid>
        <Grid item sm={6} md={4} xs={12}>
          <Box
            backgroundColor={colors.primary[400]}
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ padding: 4 }}
          >
            <StatBox
              title={results?.imoveisVendaLocacaoCount || "0"}
              subtitle="Total Imóveis Venda/Locação"
              progress="0"
              increase=""
              icon={
                <HomeWorkIcon
                  sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                />
              }
            />
          </Box>
        </Grid>
        <Grid item sm={6} md={4} xs={12}>
          <Box
            backgroundColor={colors.primary[400]}
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ padding: 4 }}
          >
            <StatBox
              title={results?.imoveisTemporadaCount || "0"}
              subtitle="Total Imóveis Temporada"
              progress="0"
              increase=""
              icon={
                <HomeWorkIcon
                  sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                />
              }
            />
          </Box>
        </Grid>
        <Grid item sm={6} md={4} xs={12}>
          <Box
            backgroundColor={colors.primary[400]}
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ padding: 4 }}
          >
            <StatBox
              title={results?.imoveisAtivoCount || "0"}
              subtitle="Total Imóveis Ativos"
              progress="0"
              increase=""
              icon={
                <HomeWorkIcon
                  sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                />
              }
            />
          </Box>
        </Grid>
        <Grid item sm={6} md={4} xs={12}>
          <Box
            backgroundColor={colors.primary[400]}
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ padding: 4 }}
          >
            <StatBox
              title={results?.imoveisAtivoVendaCount || "0"}
              subtitle="Total Imóveis Venda Ativos"
              progress="0"
              increase=""
              icon={
                <HomeWorkIcon
                  sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                />
              }
            />
          </Box>
        </Grid>
        <Grid item sm={6} md={4} xs={12}>
          <Box
            backgroundColor={colors.primary[400]}
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ padding: 4 }}
          >
            <StatBox
              title={results?.imoveisAtivoLocacaoCount || "0"}
              subtitle="Total Imóveis Locação Ativos "
              progress="0"
              increase=""
              icon={
                <HomeWorkIcon
                  sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                />
              }
            />
          </Box>
        </Grid>
        <Grid item sm={6} md={4} xs={12}>
          <Box
            backgroundColor={colors.primary[400]}
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{ padding: 4 }}
          >
            <StatBox
              title={results?.imoveisPortal8Count || "0"}
              subtitle="Imóveis Ativos Site "
              progress="0"
              increase=""
              icon={
                <HomeWorkIcon
                  sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
                />
              }
            />
          </Box>
        </Grid>
        {/*}
        <Grid item md={8} xs={12}>
          <Box
            gridColumn="span 8"
            gridRow="span 2"
            backgroundColor={colors.primary[400]}
            sx={{ padding: 4 }}
          >
            <Box
              mt="25px"
              p="0 30px"
              display="flex "
              justifyContent="space-between"
              alignItems="center"
            >
              <Box>
                <Typography
                  variant="h5"
                  fontWeight="600"
                  color={colors.grey[100]}
                >
                  Revenue Generated
                </Typography>
                <Typography
                  variant="h3"
                  fontWeight="bold"
                  color={colors.greenAccent[500]}
                >
                  $59,342.32
                </Typography>
              </Box>
              <Box>
                <IconButton>
                  <DownloadOutlinedIcon
                    sx={{ fontSize: "26px", color: colors.greenAccent[500] }}
                  />
                </IconButton>
              </Box>
            </Box>
            <Box height="250px" m="-20px 0 0 0">
              <LineChart isDashboard={true} />
            </Box>
          </Box>
        </Grid>
        <Grid item md={4} xs={12}>
          <Box
            gridColumn="span 4"
            gridRow="span 2"
            backgroundColor={colors.primary[400]}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              borderBottom={`4px solid ${colors.primary[500]}`}
              colors={colors.grey[100]}
              p="15px"
            >
              <Typography
                color={colors.grey[100]}
                variant="h5"
                fontWeight="600"
              >
                Recent Transactions
              </Typography>
            </Box>
            {mockTransactions.slice(0, 4).map((transaction, i) => (
              <Box
                key={`${transaction.txId}-${i}`}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                borderBottom={`4px solid ${colors.primary[500]}`}
                p="15px"
              >
                <Box>
                  <Typography
                    color={colors.greenAccent[500]}
                    variant="h5"
                    fontWeight="600"
                  >
                    {transaction.txId}
                  </Typography>
                  <Typography color={colors.grey[100]}>
                    {transaction.user}
                  </Typography>
                </Box>
                <Box color={colors.grey[100]}>{transaction.date}</Box>
                <Box
                  backgroundColor={colors.greenAccent[500]}
                  p="5px 10px"
                  borderRadius="4px"
                >
                  ${transaction.cost}
                </Box>
              </Box>
            ))}
          </Box>
        </Grid>
        <Grid item md={4} xs={12}>
          <Box
            gridColumn="span 4"
            gridRow="span 2"
            backgroundColor={colors.primary[400]}
            p="30px"
          >
            <Typography variant="h5" fontWeight="600">
              Campaign
            </Typography>
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              mt="25px"
            >
              <ProgressCircle size="125" />
              <Typography
                variant="h5"
                color={colors.greenAccent[500]}
                sx={{ mt: "15px" }}
              >
                $48,352 revenue generated
              </Typography>
              <Typography>
                Includes extra misc expenditures and costs
              </Typography>
            </Box>
          </Box>
        </Grid>
        <Grid item md={4} xs={12}>
          <Box
            gridColumn="span 4"
            gridRow="span 2"
            backgroundColor={colors.primary[400]}
          >
            <Typography
              variant="h5"
              fontWeight="600"
              sx={{ padding: "30px 30px 0 30px" }}
            >
              Sales Quantity
            </Typography>
            <Box height="250px" mt="-20px">
              <BarChart isDashboard={true} />
            </Box>
          </Box>
        </Grid>
        <Grid item md={4} xs={12}>
          <Box
            gridColumn="span 4"
            gridRow="span 2"
            backgroundColor={colors.primary[400]}
            padding="30px"
          >
            <Typography
              variant="h5"
              fontWeight="600"
              sx={{ marginBottom: "15px" }}
            >
              Geography Based Traffic
            </Typography>
            <Box height="200px">
              <GeographyChart isDashboard={true} />
            </Box>
          </Box>
        </Grid>
            {*/}
      </Grid>
    </Box>
  );
}
